import { render } from "./TheTopMovers.vue?vue&type=template&id=1a4a5692&scoped=true&ts=true"
import script from "./TheTopMovers.vue?vue&type=script&lang=ts"
export * from "./TheTopMovers.vue?vue&type=script&lang=ts"

import "./TheTopMovers.vue?vue&type=style&index=0&id=1a4a5692&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4a5692"]])

export default __exports__